/** @format */
import { createMachine } from 'xstate';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum SignUpMachineAction {
    SUBMIT = 'submit',
}

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum SignUpMachineState {
    FORM = 'form',
    NEARLY_THERE = 'nearly-there',
}

export const signUpMachine = createMachine({
    predictableActionArguments: true,
    id: 'sign-up-machine',
    initial: SignUpMachineState.FORM,
    states: {
        [SignUpMachineState.FORM]: {
            on: {
                [SignUpMachineAction.SUBMIT]: SignUpMachineState.NEARLY_THERE,
            },
        },
        [SignUpMachineState.NEARLY_THERE]: {},
    },
});
